'use client'

import { TitleBackgroundBlock as Block } from '@shc/ui'
import type { TypeTitleBackgroundBlockFields } from '@lib/generated-types'
import { bgColorMap } from '@lib/token-maps'
import { richTextRender } from '@lib/rich-text-base'
import slugify from 'slugify'

const TitleBackgroundBlock = ({
    sectionLink,
    title,
    titleHeading,
    description,
    textAlignment,
    overlap,
    backgroundColor,
    backgroundImage,
  }: TypeTitleBackgroundBlockFields) => {
    
  return (
    <Block
      id={typeof sectionLink !== 'undefined' ? slugify(sectionLink) : undefined}
      className={backgroundImage ? undefined : bgColorMap[backgroundColor]}
      heading={title}
      description={richTextRender(description)}
      alignment={textAlignment}
      overlap={overlap === 'true'}
      image={{
        src: backgroundImage ? `/assets/backgrounds/${backgroundImage}.webp` : undefined,
        alt: backgroundImage,
        className: backgroundImage ? bgColorMap[backgroundColor] : 'hidden'
      }}
      slots={{
        heading: titleHeading,
      }}
      slotProps={{
        heading: {
          className: `text-${textAlignment}`
        }
      }}
    />
  )
}

export default TitleBackgroundBlock
